import { Button } from "react-bootstrap";

import { EditIcon, ToolIcon } from "../../../../components/icons";

interface SchemaItemProps {
  name: string;
  handleEdit: () => void;
}

const SchemaItem: React.FC<SchemaItemProps> = ({ name, handleEdit }) => {
  const onEditClick = () => {
    handleEdit();
  };

  return (
    <div className="tool-item">
      <div className="tool-item-name">
        <span>
          <ToolIcon />
        </span>{" "}
        <div className="text-truncate">{name}</div>
      </div>
      <Button
        variant="light"
        className="btn-tool-control"
        onClick={onEditClick}
      >
        <EditIcon />
      </Button>
    </div>
  );
};

export { SchemaItem };
